/**
 * The two questions the install prompt has to answer, and neither is answerable the obvious way.
 *
 * Kept as pure functions over their inputs so they can actually be tested: a browser will not let
 * you pretend to be an iPad, and getting iPadOS wrong is the whole difficulty here.
 */

/**
 * Is this an iOS-family device?
 *
 * iPadOS 13 and later report themselves as `Macintosh` in the user-agent string — deliberately,
 * to be served desktop sites. The only reliable tell left is that a Mac has no touchscreen: a
 * `Macintosh` claiming more than one touch point is an iPad. Sniffing `iPad` alone silently
 * excludes every modern iPad, which is precisely the audience that needs the instruction, since
 * iOS has no install API at all.
 */
export function isIosLike(userAgent: string, maxTouchPoints: number): boolean {
  if (/iPad|iPhone|iPod/.test(userAgent)) return true;
  return userAgent.includes('Macintosh') && maxTouchPoints > 1;
}

/**
 * Is the app already installed and running from the home screen?
 *
 * Two mechanisms because the standard one is not universal: `display-mode: standalone` is the
 * spec, and `navigator.standalone` is Safari's own predating it. iOS supports only the second, so
 * checking only the first offers «установите приложение» to somebody already inside it.
 */
export function isStandalone(): boolean {
  if (typeof window === 'undefined') return false;
  if (window.matchMedia?.('(display-mode: standalone)').matches) return true;
  return (window.navigator as Navigator & { standalone?: boolean }).standalone === true;
}
